import React from "react"
import { Link } from "gatsby"

const renderPreviousLink = ({ prev }) => {
  let previousLink = null
  if (!prev) {
    return (
      <span className="text-gray-300 dark:text-gray-500 prev-next-text">
        Previous
      </span>
    )
  } else {
    previousLink = `${prev}`
  }

  return (
    <Link to={previousLink} className="flex items-center group btn btn-ghost">
      <span>Previous</span>
    </Link>
  )
}

const renderNextLink = ({ next }) => {
  if (next) {
    return (
      <Link to={next} className="flex items-center group btn btn-ghost">
        <span>Next</span>
      </Link>
    )
  } else {
    return (
      <span className="text-gray-300 dark:text-gray-500 prev-next-text">
        Next
      </span>
    )
  }
}

export const PrevNextPostNavigation = ({ ctx }) => {
  return (
    <nav className="flex justify-between mt-16">
      {renderPreviousLink(ctx)}
      {renderNextLink(ctx)}
    </nav>
  )
}
